"use client";

import { motion, useReducedMotion } from "framer-motion";
import { Zap, Globe, Lock } from "lucide-react";
export default function Benefits() {
  const shouldReduceMotion = useReducedMotion();
  const perks = [{
    icon: Zap,
    title: "INSTANT PROTECTION",
    description: "Activate our high-speed encryption protocols instantly. Secure your digital footprint across all devices with a single click."
  }, {
    icon: Globe,
    title: "GLOBAL ACCESS",
    description: "Bypass geo-restrictions effortlessly. Connect to our worldwide server network to access content from anywhere on the planet."
  }, {
    icon: Lock,
    title: "TOTAL PRIVACY",
    description: "Experience true anonymity with our strict no-logs policy. Your browsing habits remain yours alone, shielded from prying eyes."
  }];
  const containerVariants = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: shouldReduceMotion ? 0 : 0.1
      }
    }
  };
  const cardVariants = {
    hidden: shouldReduceMotion ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 16
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: shouldReduceMotion ? 0 : 0.42,
        ease: [0.2, 0.8, 0.2, 1] as [number, number, number, number]
      }
    }
  };
  return <section data-section-id="30450" id="activeprotectionbenefits" data-nav="dark" className="bg-background text-foreground py-24 md:py-32">
      <div className="mx-auto w-full max-w-[1440px] px-5 md:px-10">
        {}
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: shouldReduceMotion ? 0 : 0.42,
        ease: [0.2, 0.8, 0.2, 1]
      }} className="mb-16 md:mb-20">
          {}
          <div className="h-[2px] w-full mb-3 bg-primary" aria-hidden="true" />
          <p className="text-xs font-medium uppercase mb-8 text-muted-foreground" style={{
          letterSpacing: "0.18em"
        }}>
            Core Advantages
          </p>
          <h2 className="font-default font-black uppercase text-foreground" style={{
          fontSize: "clamp(2.5rem, 7vw, 6.5rem)",
          letterSpacing: "-0.015em",
          lineHeight: "0.88"
        }}>
            WHY CHOOSE
            <br />
            <span className="inline-block relative">
              VPNGENIX
              <span aria-hidden="true" className="absolute left-0 right-0 h-[2px] bg-primary" style={{
              bottom: "-6px"
            }} />
            </span>
          </h2>
        </motion.div>

        {}
        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.15
      }} className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8">
          {perks.map((perk, i) => {
          const Icon = perk.icon;
          return <motion.div data-index={i} key={i} variants={cardVariants} whileHover={shouldReduceMotion ? {} : {
            y: -4,
            transition: {
              duration: 0.22,
              ease: [0.2, 0.8, 0.2, 1]
            }
          }} className="group relative bg-card text-card-foreground rounded-lg p-7 md:p-10 border-2 border-transparent hover:border-primary transition-colors duration-200 shadow-md">
                {}
                <Icon className="w-10 h-10 mb-6 transition-colors duration-200 text-card-foreground group-hover:text-primary" strokeWidth={1.5} aria-hidden="true" />

                {}
                <div className="h-[2px] w-10 mb-5 bg-primary" aria-hidden="true" />

                {}
                <h3 className="font-default font-semibold text-card-foreground mb-4 uppercase" style={{
              fontSize: "clamp(1.5rem, 2.2vw, 2.25rem)",
              letterSpacing: "-0.01em",
              lineHeight: "1.15"
            }}>
                  {perk.title}
                </h3>

                {}
                <p className="font-default text-muted-foreground" style={{
              fontSize: "1rem",
              lineHeight: "1.55"
            }}>
                  {perk.description}
                </p>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}